'use strict';
var $ = require('jquery');
require('bootstrap-select');
var employeeGroupsService = require('./services/employeeGroupsService');
var assertExists = require('./utils/asserts').assertExists;

/**
 * Initialized the EmployeeGroupSelection component which first does fetch from backend to determine available groups for current session
 *
 * config = {id: 'string', mountOn: 'string', onGroupChange: callback, renderSingleGroup: false, readOnly: false}
 *
 * @param config - where,
 *   id  (String) - id for the component to render
 *   mountOn (String) - id for the element on page which component must be mounted on
 *   onGroupChange (function, optional) - callback function where only argument is the new value selected
 *   renderSingleGroup (Boolean, optional, default=false) - by default if only one employee group exists this component is not rendered. set to true to render
 *   readOnly (Boolean, optional, default=false) - render as read only field
 *
 *  Returns - Promise which is resolved with this components available methods:
 *   setValue(employeeGroupId)
 *   getAvailableGroups() - returns array of employee group ids available for current component
 *
 * Created by c_razmuss_a on 19/01/2018.
 *
 */
module.exports = function EmployeeGroupSelector(config) {
    assertExists(config.id, "Missing property id - mandatory value");
    assertExists(config.mountOn, "Missing  property mountOn - where this component should be rendered?");

    var employeeGroups;

    return employeeGroupsService.getEmployeeGroups()
        .then(function(result) {
            employeeGroups = result;
            if (config.renderSingleGroup || Object.keys(employeeGroups).length > 1) {
                render();
            }
            return {
                getId: function() {
                    return config.id;
                },
                setValue: setValue,
                getAvailableGroups: function () {
                    return Object.keys(employeeGroups);
                }
            };
    });

    function render() {
        var props = {
            id: config.id,
            mountOn: config.mountOn,
            employeeGroups: employeeGroups,
            readOnly: config.readOnly,
            inputName: config.inputName,
            i18nContext: config.i18nContext
        };
        var html = require('shared/jade/templates/employeeGroupSelect.jade')(props);
        $('#'+config.mountOn).replaceWith(html);
        $('#' + config.id).selectpicker();
        if (config.onChange) {
            $('#' + config.id).change(function (event) {
                config.onChange(event.target.value);
            });
        }
    }

    function setValue(value) {
        $('#'+config.id).val(value).selectpicker('render');
    }

};



//////////////////
// WEBPACK FOOTER
// ./src/shared/scripts/modules/EmployeeGroupSelect.js
// module id = OEM9
// module chunks = 2